<template>
  <div class="header">
    <div class="title">
      <img src="~@/assets/img/title.png" class="title-img" alt="" />
      <!-- <i>临江河凤凰湖辖区断面水质在线监测</i> -->
    </div>
    <div class="menu" style="margin-right: -20rem" v-if="routes[0].children">
      <div :class="current == item.path ? 'menu-item active' : 'menu-item'" v-for="(item, index) in routes[0].children"
        :key="item.path" @click="onMenuClick(item.path)">
        <span class="f-family-you">
          {{ item.title }}
        </span>
        <div v-if="index < routes[0].children.length - 1" class="menu-line"></div>
      </div>
    </div>
    <div @click="backHome" class="back_home">
      <!-- <span><i class="el-icon-s-home"></i>返回门户</span> -->
    </div>
  </div>
</template>

<script>
import { router } from '@/router/router'
import Bus from '@/config/Bus.ts'
import mapService from '@/utils/mapServices.js'

export default {
  data() {
    return {
      current: '',
      routes: [],
    }
  },
  methods: {
    backHome() {
      window.location.href = 'http://183.66.101.109:20010/#/home/index'
    },
    onMenuClick(str) {
      this.current = str
      this.$router.push(`/main/${this.current}`)
      mapService.reset()
    },
  },
  created() {
    this.routes = router.options.routes
    this.current = this.routes[0].children[0].path
  },
}
</script>

<style lang="scss" scoped>
.header {
  position: relative;
  z-index: 99;
  height: 7.8rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 2.1rem 2.4rem;

  .title {
    i {
      font-weight: 600;
      font-size: 4.1rem;
      color: #65e1c4;
      letter-spacing: 2px;
    }

    .title-img {
      width: 63.8rem;
      height: 4.8rem;
    }
  }

  .menu {
    display: flex;
    flex-direction: row;
    margin-top: 1.6rem;

    .menu-item {
      display: flex;
      align-items: center;
      text-align: center;
      font-size: 2.8rem;
      line-height: 3.6rem;
      color: rgba(151, 213, 198, 0.7);

      .menu-line {
        width: 0.2rem;
        height: 2.4rem;
        background: rgba(255, 255, 255, 0.5);
        margin: 0 2.2rem;
      }
    }

    .active {
      font-size: 3rem;
      color: #65e1c4;
      font-family: YouShe;
    }
  }

  .back_home {
    font-size: 3rem;
    color: rgba(151, 213, 198, 0.7);
    font-family: YouShe;
    padding-top: 1.8rem;
  }
}
</style>
